import { render, button, playerCard, on } from './components';
import { GameManager } from '../game';
import { PlayerState, GameConfig } from '../types';

export interface LobbyCallbacks {
  onStart: () => void;
  onHelp?: () => void;
  onTutorial?: () => void;
  onCustomRules?: () => void;
}

export function renderLobby(
  game: GameManager,
  currentUserId: string,
  callbacks: LobbyCallbacks
): void {
  const state = game.getState();
  const players = state.players;

  render(`
    <div class="lobby" style="text-align: center; padding: 40px 20px;">
      <h1 style="
        color: #00fff5;
        text-shadow: 0 0 30px #00fff5, 0 0 60px #00fff5;
        font-size: clamp(2rem, 8vw, 3rem);
        margin-bottom: 10px;
        letter-spacing: 4px;
      ">⚔️ FLAG BATTLE ⚔️</h1>
      
      <p style="color: #aaa; margin-bottom: 40px; font-size: 1.1rem;">
        デッキを構築し、フラッグを奪い合え!
      </p>

      <div style="
        background: rgba(0,0,0,0.3);
        border-radius: 12px;
        padding: 20px;
        max-width: 600px;
        margin: 0 auto 30px;
        border: 1px solid rgba(0,255,245,0.2);
      ">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <span style="color: #00fff5; font-size: 1.2rem;">プレイヤー</span>
          <span style="color: #fff;">${players.length} / 8</span>
        </div>

        <div id="playerList" style="
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          justify-content: center;
          min-height: 80px;
        ">
          ${players.length === 0 
            ? '<p style="color: #666;">プレイヤーがいません</p>'
            : players.map((p) => playerCard(
                p.info.name,
                p.fans,
                p.info.type === 'bot',
                p.info.id === currentUserId
              )).join('')
          }
        </div>
      </div>

      <div style="display: flex; gap: 16px; justify-content: center; flex-wrap: wrap;">
        ${button('🎮 ゲーム開始', 'btnStart', 'primary')}
        ${button('⚙️ ルール設定', 'btnCustomRules', 'secondary')}
      </div>

      <div style="display: flex; gap: 12px; justify-content: center; margin-top: 20px; flex-wrap: wrap;">
        ${button('📚 チュートリアル', 'btnTutorial', 'ghost')}
        ${button('❓ ヘルプ', 'btnHelp', 'ghost')}
      </div>

      <div style="margin-top: 40px; color: #666; font-size: 0.9rem;">
        <p>1-8人でプレイ可能 / 奇数の場合はBotが自動追加されます</p>
      </div>
    </div>
    
    <style>
      .btn-ghost {
        background: transparent !important;
        border: 1px solid rgba(255,255,255,0.3) !important;
        color: #aaa !important;
      }
      .btn-ghost:hover {
        background: rgba(255,255,255,0.1) !important;
        color: #fff !important;
      }
    </style>
  `);

  // イベントバインド
  document.getElementById('btnStart')?.addEventListener('click', callbacks.onStart);
  document.getElementById('btnCustomRules')?.addEventListener('click', () => callbacks.onCustomRules?.());
  document.getElementById('btnTutorial')?.addEventListener('click', () => callbacks.onTutorial?.());
  document.getElementById('btnHelp')?.addEventListener('click', () => callbacks.onHelp?.());
}

// ルール説明モーダル
export function renderRulesModal(onClose: () => void): void {
  const overlay = document.createElement('div');
  overlay.id = 'rulesModal';
  overlay.innerHTML = `
    <div style="
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    ">
      <div style="
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
        border: 2px solid #00fff5;
        border-radius: 16px;
        padding: 32px;
        max-width: 600px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
      ">
        <h2 style="color: #00fff5; margin-bottom: 20px;">📖 ルール説明</h2>
        
        <div style="color: #ccc; line-height: 1.8;">
          <h3 style="color: #ffd700; margin: 16px 0 8px;">🎯 ゲームの流れ</h3>
          <p>予選7ラウンド + 決勝戦で優勝者を決定</p>
          
          <h3 style="color: #ffd700; margin: 16px 0 8px;">📦 デッキフェイズ</h3>
          <p>会場を選んでカードを入手し、デッキを強化</p>
          
          <h3 style="color: #ffd700; margin: 16px 0 8px;">⚔️ マッチフェイズ</h3>
          <ul style="margin-left: 20px;">
            <li>デッキからカードを自動公開</li>
            <li>パワーが高い方がフラッグ保持</li>
            <li>上回れないorベンチ満杯で決着</li>
          </ul>
          
          <h3 style="color: #ffd700; margin: 16px 0 8px;">🏆 勝利条件</h3>
          <p>マッチに勝利してファンを獲得し、決勝進出を目指せ!</p>
        </div>
        
        <button class="btn" id="btnCloseRules" style="margin-top: 24px; width: 100%;">閉じる</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(overlay);
  document.getElementById('btnCloseRules')?.addEventListener('click', () => {
    overlay.remove();
    onClose();
  });
}
